import React, { memo } from "react";
import { clsx } from "clsx";

interface PillOptionProps {
  selected: boolean;
  label: string;
  role: "checkbox" | "radio";
  onToggle: () => void;
}

export const PillOption = memo(function PillOption({
  selected,
  onToggle,
  label,
  role,
}: PillOptionProps) {
  return (
    <li
      onClick={onToggle}
      onKeyDown={(e) => {
        if (e.key === " " || e.key === "Enter") {
          e.preventDefault();
          onToggle();
        }
      }}
      tabIndex={0}
      role={role}
      aria-checked={selected}
      className={clsx(
        "inline-flex h-8.5 cursor-pointer items-center gap-3 rounded-full border bg-background px-6 py-2 font-medium hover:bg-accent hover:text-accent-foreground dark:bg-input/30 dark:hover:bg-input/50 [&_svg:not([class*='size-'])]:size-4",
        {
          "mx-[-1px] border-2 border-foreground": selected,
        },
      )}
    >
      {label}
    </li>
  );
});
